import 'whatwg-fetch'
import React, {Component} from 'react'
import {actions as kandyActions} from 'kandy-redux'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Header from '../components/Header'
import VideoClaimIncoming from '../components/VideoClaimIncoming'
// 视频理赔通话房间的全局宿主：挂在这里使其脱离工单详情子标签树，
// 切换到理算信息/领款人/照片取证/风险预警/处理记录等标签时通话不会被卸载中断
import VideoClaimRoomHost from '../components/VideoClaimRoomHost'
import {agentActions, dashboardActions, serviceRequestActions, currentCallActions} from '../actions'
import {screenShotActions, report, reportPreviewActions, serviceRequestPiccActions} from '../lossAss/actions'
import t from '../localization'

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    
    renderNotice() {
        const {location} = this.props;

        if (location.pathname === '/') {
            return (
                <h4 style={ {
                    textAlign: 'center',
                    top: '100px',
                    position: 'relative'
                } }>{t('App::wrongUrlTryAgain')}</h4>
            )
        } else {
            return null
        }
    }

    renderHeader() {
        const {actions, currentAgent, currentCustomerCount, dashboard, routerState, session, location} = this.props;
        if (location.pathname.indexOf('login') > -1) {

            return (undefined)
        } else {

            return (<Header
                actions={actions}
                currentAgent={currentAgent}
                currentCustomerCount={currentCustomerCount}
                dashboard={dashboard}
                routerState={routerState}
                session={session}
                history={this.props.history}
            />)
        }
    }


    render() {
        const {children} = this.props;
        return (
            <React.Fragment>
                {this.renderHeader()}
                {this.renderNotice()}
                {children}
                {/* 视频理赔全局呼入弹窗（由 socket 事件驱动） */}
                <VideoClaimIncoming />
                {/* 视频理赔通话房间（全局常驻，跨子标签保持通话） */}
                <VideoClaimRoomHost />
                {/* <UploadNotification /> */}
            </React.Fragment>
        )
    }
}

App.propTypes = {
    children: PropTypes.node
};

let mapStateToProps = (state) => {
    return {
        companyId: state.company.id,
        currentAgent: state.app.currentAgent.userInfo,
        currentCustomerCount: state.app.customers.current.length,
        dashboard: state.app.dashboard,
        routerState: state.router,
        session: state.app.kandy.auth,
    }
};

let mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({}, kandyActions, agentActions, dashboardActions, serviceRequestActions,
            currentCallActions, screenShotActions, report, reportPreviewActions, serviceRequestPiccActions), dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(App))
